// The dashboard's popovers (Select, ActionMenu) are position: fixed from their trigger's rect, so a scroll or
// resize that moves the trigger would leave one behind: it closes then. One that doesn't move the trigger (the
// popover's own list, the page behind a modal dialog, a browser bringing an item into view) leaves it open.

import { useEffect, useRef, type RefObject } from 'react';

export function useCloseWhenMoved(open: boolean, trigger: RefObject<HTMLElement | null>, close: () => void) {
  const latest = useRef(close);
  latest.current = close;
  useEffect(() => {
    if (!open) return;
    const at = trigger.current?.getBoundingClientRect();
    const check = () => {
      const now = trigger.current?.getBoundingClientRect();
      if (!at || !now || Math.abs(now.top - at.top) >= 0.5 || Math.abs(now.left - at.left) >= 0.5) latest.current();
    };
    window.addEventListener('scroll', check, true);
    window.addEventListener('resize', check);
    return () => {
      window.removeEventListener('scroll', check, true);
      window.removeEventListener('resize', check);
    };
  }, [open, trigger]);
}
